import React from 'react';

const ClearAllStorage = () => {
    const handleClick = (e) => {
        // Запобігаємо спливанню, щоб не спрацював клік батьківського HoldButton, 
        // якщо це необхідно, хоча в меню це може бути не потрібно.
        // e.stopPropagation(); 
        localStorage.clear();
        window.location.reload(); // Перезавантажимо сторінку для очищення стейту
    };

    return (
        <div
            style={{
                width: "100%", 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center",
                padding: "0.5rem 0"
            }}
            onClick={handleClick}
        >
            Clear All
        </div>
    );
};

export {ClearAllStorage};
